<template>
  <layout-mobile>
    <page-header-search></page-header-search>

    <div class="flex flex-between flex-vertical-center mt-50 mb-100">
      <pipeline-views class="mb-0" is-mobile></pipeline-views>
      <button-link
        class="ml-100"
        size=""
        @click="$refs.recentlyViewModal.open()"
      >Recent Leads
      </button-link>
    </div>

    <tabs-mobile v-model="currentTab">
      <b-tab-item value="contacting" label="Contact Not Made">
        <contacting-pipeline-mobile></contacting-pipeline-mobile>
      </b-tab-item>

      <b-tab-item value="active" label="Active">
        <active-pipeline-mobile></active-pipeline-mobile>
      </b-tab-item>

      <b-tab-item value="followUp" label="Follow Up">
        <follow-up-pipeline-mobile></follow-up-pipeline-mobile>
      </b-tab-item>
    </tabs-mobile>

    <modal-before-container>
      <modal-default
        ref="recentlyViewModal"
        title="Recently Viewed Leads"
      >
        <recent-leads-modal></recent-leads-modal>
      </modal-default>
    </modal-before-container>
  </layout-mobile>
</template>

<script>
import PageHeaderSearch from "../../layouts/page/components/PageHeaderSearch";
import PipelineViews from "./components/PipelineViews";
import RecentLeadsModal from "../../layouts/page/components/RecentLeadsModal";
import MobileStatusHeader from "./components/MobileStatusHeader";
import MobileStatusBody from "./components/MobileStatusBody";
import TabsMobile from "../../components/tab/TabsMobile";
import ActivePipelineMobile from "./states/active/ActivePipelineMobile";
import ContactingPipelineMobile from "./states/contacting/ContactingPipelineMobile";
import FollowUpPipelineMobile from "./states/follow-up/FollowUpPipelineMobile";
import CompletedPipelineMobile from "./states/completed/CompletedPipelineMobile";

export default {
  name: "PipelinePageMobile",
  components: {
    FollowUpPipelineMobile,
    ContactingPipelineMobile,
    ActivePipelineMobile,
    TabsMobile, MobileStatusBody, MobileStatusHeader, RecentLeadsModal, PipelineViews, PageHeaderSearch},
  data() {
    return {
      isOpen: null,
      currentTab: "active",
    };
  },
  computed: {
    statuses() {
      return this.$store.getters['pipeline/statuses'];
    },
    filteredStatuses() {
      const view = this.$store.getters["pipeline/selectedPipelineView"];

      if (view) {
        return this.statuses.filter(s => view.status_ids.includes(s.id));
      }

      return this.statuses;
    },
  },
};
</script>

<style lang="scss" scoped>

::v-deep {

  .tabs {
    margin-bottom: 10px;
  }

  .tabs li.is-active a {
    border-bottom-color: #1C6C7D;
    color: #1C6C7D;
  }

  .tabs a {
    border-width: 4px;
    padding: 0.25rem 0.5rem 0.5rem;
    line-height: 18px;
  }
}
</style>
